import React from 'react';
import './Footer.css';

export default function Footer() {
  return <footer className="footer"><div className="footer-copywright"><h3>© {new Date().getFullYear()} Jide Oyelayo. All rights reserved.</h3></div></footer>;
}
